module.exports = __webpack_public_path__ + "img/carousel-clientes-5.80c39396.png";